<template>
  <div class="nurse-schedule">
    <div class="container">
      <div class="board">
        <h2 class="title">Agendar consulta para paciente</h2>
        <div class="row">
          <div class="col-md-6 field">
            <label style="color: gray">Especialidade:</label>
            <BaseSelectWithSearch
              id="specialities" v-model="selectedSpeciality"
              :placeholder="'Selecione uma especialidade'"
              :options="specialitiesOptions"
              @filtered-option="getDoctors"
            />
          </div>

          <div class="col-md-6 field">
            <label style="color: gray">Profisisonal de saúde:</label>
            <BaseSelectWithSearch
              id="doctors" :options="doctorsOptions"
              :placeholder="'Selecione um profissional de saúde'"
              v-model="selectedDoctor"
              @filtered-option="getSelectedDoctorId"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-2">
          <label style="color: gray">Unidade:</label>
            <BaseSelectWithSearch
              id="units" v-model="selectedUnit"
              :placeholder="'Selecione uma unidade'"
              :options="unitsOptions"
              @filtered-option="getSelectedUnitId"
            />
          </div>

          <div class="col-md-6 mt-2">
            <label style="color: gray">Paciente:</label>

            <BaseSelectWithSearch
              id="patients" v-model="selectedPatient"
              :placeholder="'Selecione um paciente'"
              :options="patientsOptions"
              @filtered-option="getSelectedPatientId"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mt-2">
            <label style="color: gray">Observação:</label>
            <textarea
              cols="46" name="" id="" rows="5"
              v-model="observation"
              class="form-control form-control-textarea"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-8">
            <div class="doctors-list-card-body mt-4">
              <ScheduleTable
                :entity="selectedDoctor"
                only-select-slot
                @on-select-slot="getSlotSelected"
                :unit-id="selectedUnitId"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <button type="submit" class="button2 mt-4 offset-5"
            @click.prevent="showConfirmationModal()"
          >
            Agendar consulta
          </button>
        </div>

      </div>
    </div>

    <BModal id="scheduleCreated" ref="scheduleCreated" hide-footer hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Consulta agendada
        </h4>
      </div>
    </BModal>

    <BModal id="confirmationModal" ref="confirmationModal" hide-footer
            hide-header centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
           {{ `Tem certeza de que ${alertMessage}` }}
        </h4>
        <BButton class="button2 mb-2" block @click="scheduleAppointment()">
          Confirmar
        </BButton>

        <BButton class="button2 mb-2" block
                @click="hideConfirmationSlotsModal()"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

  </div>
</template>

<script>
  import ScheduleTable from '@/components/Schedule/ScheduleTable.vue';
import BaseSelectWithSearch from './base/BaseSelectWithSearch.vue';

  export default {
    components: {
      ScheduleTable,
    },

    data() {
      return {
        doctorsList: [],
        specialitiesList: [],
        patientsList: [],
        unitsList: [],
        selectedDoctor: {},
        selectedUnitId: '',
        selectedPatientId: '',
        selectedDateId: '',
        selectedSpeciality: '',
        selectedUnit: '',
        selectedPatient: '',
        selectedDate: '',
        selectedHour: '',
        observation: '',
        alertMessage: 'quer agendar esta consulta?',
      }
    },

    beforeMount() {
      this.listPatients()
    },

    mounted() {
      this.getUnits()
      this.getSpecialities()
      this.getDoctors()
    },

    methods: {
      accountCreatedModal() { this.$bvModal.show("scheduleCreated") },
      showConfirmationModal() { this.$bvModal.show("confirmationModal") },
      hideConfirmationSlotsModal() { this.$bvModal.hide("confirmationModal") },
      getSelectedUnitId(id) { this.selectedUnitId = id },
      getSelectedPatientId(id) { this.selectedPatientId = id },

      getSelectedDoctorId(selectedValue) {
        let option_filtered = this.doctorsList.find(option => selectedValue === option.id)
        this.selectedDoctor = option_filtered
        this.selectedDoctor
      },

      getSlotSelected(value) {
        this.selectedDate = value.slot_date,
        this.selectedHour = value.hour,
        this.selectedDateId = value.slot_id
      },

      getUnits() {
        this.$store.dispatch('slot/getUnits')
            .then(response => this.unitsList = response.data)
        
      },

      getSpecialities() {
        this.$store.dispatch('speciality/fetchAllSpecialities')
                   .then(response => this.specialitiesList = response.data)
        this.slotDays()
      },

      getDoctors(id) {
        let medical_specialty = { medical_specialty: id }
        this.$store.dispatch('doctor/fetchDoctors', medical_specialty)
                   .then(response => this.doctorsList = response.data)
      },

      listPatients() {
        this.$store.dispatch('user/fetchPatients')
                   .then(response => this.patientsList = response.data)
      },

      scheduleAppointment() {
        let appointment = {
          scheduled_at: `${this.selectedDate} ${this.selectedHour}:00`,
          scheduled_until: `${this.selectedDate} 00:00:00`,
          user_id: this.selectedPatientId,
          slot_id: this.selectedDateId,
          observation: this.observation
        }
        this.$store.dispatch('appointments/createAppointmentByNurse', appointment)
          .then(response => {
            response
            this.accountCreatedModal()
            setTimeout(() => this.$router.push('/dashboard'), 3500);
        })
        this.scheduleCreated()
      }
    },

    computed: {
      specialitiesOptions() { return this.specialitiesList },
      doctorsOptions() { return this.doctorsList },
      unitsOptions() { return this.selectedDoctor.id ? this.unitsList : [] },
      patientsOptions() { return this.patientsList }
    },

    watch: {}
  }
</script>

<style>

</style>
